module.exports = __webpack_public_path__ + "img/battery-ok.0cdfb90c.svg";